import Vue from 'vue'
import Router from 'vue-router'
const Detail = () => import('../views/Detail.vue')
const Home = () => import('@/views/Home')
const List = () => import('@/views/List')
const testList = () => import('@/views/testList')

Vue.use(Router);

export function createRouter() {
  return new Router({
    mode: "history",
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { name: "Home", path: "/", component: Home },
      { name: "List", path: "/list/:type/:query", component: List },
      { name: "Detail", path: "/detail/:id(\\d+)?", component: Detail },
      { name: "testList", path: "/testList", component: testList }
    ]
  });
}



// WEBPACK FOOTER //
// src/router/index.js